import { useCallback } from 'react'

import { useMountedPromiseFn, useDetailState } from 'shared/hooks'
import { services } from 'core/upload/data-access'
import { SingleNFT, MultipleNFT } from 'core/upload/models'

export const useUpload = () => {
    const [state, setState] = useDetailState<void>()

    const uploadApi = useMountedPromiseFn(services.upload)
    const upload = useCallback(
        (params: SingleNFT) => {
            setState({ loading: true })
            return uploadApi(params)
                .then(() => {
                    setState({ loading: false })
                    return
                })
                .catch(err => {
                    setState({ loading: false })
                    return Promise.reject(err)
                })
        },
        [setState, uploadApi]
    )

    const uploadZipApi = useMountedPromiseFn(services.uploadZip)
    const uploadZip = useCallback(
        (params: MultipleNFT) => {
            setState({ loading: true })
            return uploadZipApi(params)
                .then(() => {
                    setState({ loading: false })
                    return
                })
                .catch(err => {
                    setState({ loading: false })
                    return Promise.reject(err)
                })
        },
        [setState, uploadZipApi]
    )
    return {
        ...state,
        methods: {
            upload,
            uploadZip
        }
    }
}
